module.exports = __webpack_public_path__ + "kangping/img/male.9fde0dc9.png";